/**
 * request_portfolio 交互态提交的 action。
 * 新交互态只有「投资账户 / 银行账户」两个选项，均进入 PlaidConnectFlow 连接链路。
 */
export const REQUEST_PORTFOLIO_ACTION = {
  CONNECT_INVESTMENT: "connect_investment",
  CONNECT_BANK: "connect_bank",
} as const;

type RequestPortfolioAction =
  (typeof REQUEST_PORTFOLIO_ACTION)[keyof typeof REQUEST_PORTFOLIO_ACTION];

export type RequestPortfolioCardAction = RequestPortfolioAction;

/**
 * 历史消息查看态兼容：旧版卡片提交过的 action 值。
 * 交互态不再产生这些值，但聊天历史中的 tool result 仍会携带，
 * `parseRequestPortfolioResult` 需要继续识别以保证查看态渲染不回退。
 */
export const LEGACY_REQUEST_PORTFOLIO_ACTION = {
  CONNECT_PLAID: "connect_plaid",
  SCREENSHOT_RECOGNIZED: "screenshot_recognized",
  PDF_RECOGNIZED: "pdf_recognized",
  SKIPPED: "skipped",
  FEEDBACK: "feedback",
} as const;
